import { render } from "./MovieItem.vue?vue&type=template&id=63463c32&ts=true"
import script from "./MovieItem.vue?vue&type=script&lang=ts"
export * from "./MovieItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__